import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UIRouterModule } from '@uirouter/angular';

import { PhonePipe } from './pipes/phone';
import { XmCurrencyPipe } from './pipes/currency';
import { IMEIPipe } from './pipes/imei';
import { StripHtml } from './pipes/strip-html';
import { ConvertUnitPipe } from './pipes/unit';
import { KeysPipe } from './pipes/keys';
import { SafeHtmlPipe } from './pipes/html';
import { XmContentChange } from './pipes/contentChange';

import { XmMask } from './directives/mask';
import { XmButtonClick } from './directives/button';
import { XmAriaDescribedBy } from './directives/aria-describedby';
import { XmAriaInvalid } from './directives/aria-invalid';
import { XmAriaFocus } from './directives/aria-focus';
import { XmAriaHidden } from './directives/aria-hidden';
import { XmAriaDisabled } from './directives/aria-disabled';
import { XmRadioControl } from './directives/radio';
import { XmMediaImageComponent } from './media/image/image';
import { XmResponsiveImageComponent } from './media/responsive-image/responsive-image';
import { CmsTextComponent } from './cms-text/text';
import { XmEmptyComponent } from './empty/empty';
import { XmDropdownComponent } from './dropdown/dropdown';
import { XmDecoratedTextComponent } from './decorated-text/decorated-text';
import { XmPromiseBtn } from './directives/promise-button-loader';
import { XmCheckboxDirective } from './directives/aria-checked';
import { XmEscKey } from './directives/esc-key.directive';

@NgModule({
    declarations: [
        PhonePipe,
        IMEIPipe,
        XmContentChange,
        ConvertUnitPipe,
        KeysPipe,
        SafeHtmlPipe,
        StripHtml,
        XmCurrencyPipe,
        XmMask,
        XmButtonClick,
        XmAriaDescribedBy,
        XmAriaInvalid,
        XmAriaFocus,
        XmAriaHidden,
        XmAriaDisabled,
        XmRadioControl,
        XmMediaImageComponent,
        XmResponsiveImageComponent,
        CmsTextComponent,
        XmDecoratedTextComponent,
        XmEmptyComponent,
        XmDropdownComponent,
        XmPromiseBtn,
        XmCheckboxDirective,
        XmEscKey
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        UIRouterModule,
        DecimalPipe,
        PhonePipe,
        XmCurrencyPipe,
        IMEIPipe,
        XmContentChange,
        ConvertUnitPipe,
        KeysPipe,
        SafeHtmlPipe,
        StripHtml,
        XmMask,
        XmButtonClick,
        XmAriaDescribedBy,
        XmAriaInvalid,
        XmAriaFocus,
        XmAriaHidden,
        XmAriaDisabled,
        XmRadioControl,
        XmMediaImageComponent,
        XmResponsiveImageComponent,
        CmsTextComponent,
        XmDecoratedTextComponent,
        FormsModule,
        ReactiveFormsModule,
        XmEmptyComponent,
        XmDropdownComponent,
        XmPromiseBtn,
        XmCheckboxDirective,
        XmEscKey
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        UIRouterModule
    ],
    providers: [
        DatePipe,
        CurrencyPipe,
        PhonePipe,
        XmCurrencyPipe,
        StripHtml
    ]
})
export class SharedModule {}
